const CONSOLE_KEY = 'amaConsole';

export const isAmaConsoleEnabled = (): boolean => {
  const inUrl = window.location.search.indexOf('amaConsole=true') !== -1;

  try {
    if (inUrl) {
      sessionStorage.setItem(CONSOLE_KEY, 'true');
      return true;
    }
    return sessionStorage.getItem(CONSOLE_KEY) === 'true';
  } catch (e) {
    return inUrl;
  }
};
